<agr-table
  (keydown.enter)="$event.preventDefault()"
  #feedAdviceTable
  [config]="tableConfig"
></agr-table>
<ng-template #barnNameTemplate let-row="row">
  <mat-select
    [hideSingleSelectionIndicator]="true"
    class="text--small"
    [value]="getBarn(row)"
    placeholder="{{ 'farm-result.select-barn-placeholder' | translate }}"
    (selectionChange)="selectBarn($event, row)"
    [attr.data-test]="'farm-result__barnrows_barn-selector_' + row.id"
  >
    <mat-option [value]="null">
      {{ 'farm-result.select-barn-placeholder' | translate }}
    </mat-option>
    <mat-option *ngFor="let barn of barns$ | async" [value]="barn">
      {{ barn.name }}
    </mat-option>
  </mat-select>
  <span> {{ row.barn?.name }} </span>
</ng-template>

<div class="spacing--margin-all mat-button-row">
  <button
    mat-flat-button
    class="flex__child"
    color="primary"
    data-test="farm-result__save"
    (click)="save()"
  >
    {{ 'save' | translate }}
  </button>
</div>
